<template>
  <div>
    <div class="mrB20" />
    <div class="comm_view_wrap">
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_DTSVC_ID')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <div class="comm_label">
            {{ frame0.dataServiceId }}
          </div>
        </div>
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_DTSVC_NM')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-5">
          <div class="comm_label">
            {{ frame0.dataServiceName }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_DTSVC_URL')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-5">
          <div class="comm_label">
            {{ frame0.dataServiceUniformresourcelocator }}
          </div>
        </div>
     
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_PAGE_ID')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-5">
          <div class="comm_label">
            {{ frame0.pageId }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_COND')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-11">
          <div class="dp_flex">
            <textarea
              v-model="ruleConditions"
              name="name"
              :readonly="true"
            />
            <div class="msg_btn_group">
              <sui-button
                type="button"
                name="button"
                class="comm_sbtn_border"
                @click="onClickCondConfig"
              >
                {{ $t('MSG_TXT_COND_SET') }}
              </sui-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="comm_btn_wrap">
      <sui-button
        v-permission:update="pageId"
        type="button"
        class="comm_btn_solid"
        @click="onClickSave"
      >
        {{ $t('MSG_BTN_SAVE') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00001_T02', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    ruleUid: {
      type: String,
      default: null,
    },
    selectedRowData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      ruleConditions: '',
      ruleConditionInfo: {
        handConditionList: [],
        autoConditionList: [],
      },
      frame0: {
        dataServiceName: '',
        dataServiceId: '',
        dataServiceUniformresourcelocator: '',
        pageId: '',
      },
    };
  },
  computed: {},
  watch: {
    ruleUid() {
      if (!utils.isEmpty(this.selectedRowData)) {
        this.setRuleData();
        this.setRuleConditions();
        this.ruleConditionInfo = {
          handConditionList: [],
          autoConditionList: [],
        };
        // 초기 데이터 생성
        this.saveSnapshot(this.makeSnapshot());
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (!utils.isEmpty(this.selectedRowData)) {
        this.setRuleData();
        this.setRuleConditions();
        // 초기 데이터 생성
        this.saveSnapshot(this.makeSnapshot());
      } else {
        // 초기 데이터 생성
        this.saveSnapshot(this.makeSnapshot());
      }
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     * 저장되지 않은 데이터 확인
     */
    makeSnapshot() {
      const ruleConditionList = utils.concat(this.ruleConditionInfo.handConditionList,
        this.ruleConditionInfo.autoConditionList);
      const dataParams = {
        insertRuleConditionList: ruleConditionList,
      };

      return dataParams;
    },
    /**
     * 선택 된 row 룰 기본정보 셋팅
     */
    setRuleData() {
      utils.forEach(this.frame0, (value, key) => {
        this.frame0[key] = this.selectedRowData[key];
      });
    },
    /**
     * 조건 항목 text 조회
     */
    setRuleConditions() {
      http.request(this.pageId, 'DTS_CMR_00015', {
        path: {
          'rule-uid': this.ruleUid,
        },
      }).then(res => {
        this.ruleConditions = res.data.ruleText;
      });
    },
    /**
     * 조건설정 팝업
     */
    onClickCondConfig() {
      if (!this.selectedRowCheck()) return false;

      utils.openLayerPopup('PGE_CMR_00008', this.onCondConfigPopupCallback, {
        pageInitialData: {
          ruleUid: this.ruleUid,
          ruleName: this.selectedRowData.ruleName,
          ruleConditionInfo: this.ruleConditionInfo,
          dataServiceId: this.selectedRowData.dataServiceId,
        },
        size: 'xlg',
      });

      return null;
    },
    onCondConfigPopupCallback(node) {
      if (!utils.isEmpty(node)) {
        this.ruleConditionInfo = node;
      }
    },
    /**
     * 저장
     */
    onClickSave() {
      const ruleConditionList = utils.concat(this.ruleConditionInfo.handConditionList,
        this.ruleConditionInfo.autoConditionList);
      const dataParams = {
        insertRuleConditionList: ruleConditionList,
      };

      if (!this.selectedRowCheck()) return false;

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, 'DTS_CMR_00046', {
          path: {
            'rule-uid': this.ruleUid,
          },
          data: dataParams,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
          this.setRuleConditions();
          // 초기 데이터 생성
          this.saveSnapshot(this.makeSnapshot());
        });
      });

      return true;
    },
    selectedRowCheck() {
      if (utils.isEmpty(utils.trim(this.ruleUid))) {
        utils.messageBox('warning', this.$t('MSG_ALT_RUL_NOT_INFO'));
        return false;
      }
      return true;
    },
  },
  datasets: [],
};
</script>
<style scoped>
</style>
